import { offCanvas } from '../offcanvas';
import { initThemeToggle } from '../theme-toggle';
import { animateIcons } from '../icons-animation';

import * as utils from '../../utils';

import './header.css';

import aerovalFullLogo from '../../assets/images/logo/full_logo.svg';

export function renderHeader(): HTMLElement {
	const header = document.createElement('header');
	header.innerHTML = `
		<div id="external_header" style="position: absolute; top: 0; width: 100%; display: contents;"></div>
		<nav id="header-content" class="navbar navbar-expand-lg bg-light">
			<div class="container-fluid px-2">
				<a class="navbar-brand p-1" href="/">
					<img id="header-logo" class="full-logo" src='${aerovalFullLogo}' style="height: 30px; width: 117.23px; padding-top: 0;" alt="logo_aeroval">
				</a>
				<div class="d-flex align-items-center order-lg-2 ms-auto">
					<button id="toggle-theme" class="btn btn-outline-light rounded-circle me-2"></button>
					<button id="toggle-settings" class="btn me-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvas-settings" aria-controls="offcanvas-settings">
						<i class="bi bi-gear-fill"></i>
					</button>
					<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
						<span class="navbar-toggler-icon"></span>
					</button>
				</div>
				<div class="collapse navbar-collapse" id="navbarCollapse" style="padding-top: 5px;">
				<ul class="navbar-nav me-auto my-2 my-lg-0">
					<li class="nav-item">
					<a id="overall-link" class="nav-link" href="#about"><i class="bi bi-info-circle-fill me-1"></i>About</a>
					</li>
					<li class="nav-item" style="display: none;">
						<a id="lab-link" class="nav-link" href="#lab" title="Make your own experiment"><i class="bi bi-vial me-1"></i>Laboratory</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#news" title="News"><i class="bi bi-bluesky me-1"></i>News</a>
					</li>
					<!--li class="nav-item">
						<a class="nav-link" href="#contribute" title="Contribute to AeroVal"><i class="bi bi-users me-1"></i>Contribute</a>
					</li-->
					<li class="nav-item">
						<a class="nav-link" href="#contact" title="Contact Us"><i class="bi bi-send-fill me-1"></i>Contact</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" href="#notebooks" title="Notebooks"><i class="bi bi-code-slash me-1"></i>Notebooks</a>
					</li>
					<!--li class="nav-item">
						<a class="nav-link" href="#my-aeroval" title="My AeroVal"><i class="bi bi-user me-1"></i>My AeroVal</a>
					</li-->
					<li class="nav-item">
						<a class="nav-link" href="#privacy" title="Contact Us"><i class="bi bi-fingerprint me-1"></i>Privacy</a>
					</li>
				</ul>
				</div>
			</div>
		</nav>
		<div id="offcanvas-content"></div>
    `;
	return header;
}

/*on document ready*/
document.addEventListener('DOMContentLoaded', function () {

	initThemeToggle('toggle-theme')
	if (!window.location.pathname.includes('pages')) offCanvas(['general']);
	showCurrentPage();
	enableScrollStatus();
	applyCAMSTheme();
	animateIcons();

	// menu events
	menuEvents();

	addFAQ();
});

function showCurrentPage() {
	// Hide all content elements
	const allContent = document.querySelectorAll('.main-content');
	allContent.forEach((content) => {
		(content as HTMLElement).style.display = 'none';
	});

	const hash: string = new URL(window.location.href).hash;

	if (hash) {
		// add active class to corresponding nav link
		const targetElement = document.querySelector(hash);
		const navLink = document.querySelector(`[href="${hash}"]`);

		if (navLink instanceof HTMLAnchorElement) {
			navLink.classList.add('active');
		}

		// show content
		if (targetElement instanceof HTMLElement) {
			targetElement.style.display = 'block';
		}
	} else {
		// add active class to corresponding nav link
		const targetElement = document.querySelector('#index');
		const navLink = document.querySelector(`[href="#index"]`);

		if (navLink instanceof HTMLAnchorElement) {
			navLink.classList.add('active');
		}

		// show content
		if (targetElement instanceof HTMLElement) {
			targetElement.style.display = 'block';
		}
	}
}

function menuEvents() {
	const navLinks = document.querySelectorAll('.nav-link');

	// Function to handle click on nav links
	function handleNavLinkClick(event: Event) {
		event.preventDefault();

		utils.removeActiveClass(); // Remove 'active' class from all nav links

		const targetId = (event.target as HTMLElement).getAttribute('href') as string;
		const targetElement = document.querySelector(targetId);

		// Hide all content elements
		const allContent = document.querySelectorAll('.main-content');
		allContent.forEach((content) => {
			(content as HTMLElement).style.display = 'none';
		});

		// Show only the target content
		if (targetElement instanceof HTMLElement) {
			targetElement.style.display = 'block';
			targetElement.classList.add('active');
		}

		// Add 'active' class to the selected link
		(event.target as HTMLAnchorElement).classList.add('active');

		// Update the URL without page reload
		const url = new URL(window.location.href);
		url.hash = targetId;
		history.pushState(null, '', url.toString());
	}

	// Add click event listener to nav links
	navLinks.forEach((navLink) => {
		navLink.addEventListener('click', handleNavLinkClick);
	});
}

function enableScrollStatus() {
	window.addEventListener('scroll', function () {
		const navbar = document.querySelector('nav.navbar');
		if (navbar instanceof HTMLElement) {
			window.scrollY > 30 ? navbar.classList.add('scrolled') : navbar.classList.remove('scrolled');
		}
	});
}

function applyCAMSTheme() {
	if (window.location.host.includes('cams') || window.location.host.includes('atmosphere.copernicus')) {
		const navbar = document.querySelector('nav.navbar');
		if (navbar instanceof HTMLElement) {
			navbar.style.position = 'sticky';
		}

		const externalHeader = document.getElementById('external_header');
		if (externalHeader instanceof HTMLElement) {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', '../includes/cams/header.html');
			xhr.onreadystatechange = function () {
				if (xhr.readyState === XMLHttpRequest.DONE) {
					if (xhr.status === 200) {
						externalHeader.innerHTML = xhr.responseText;
					} else {
						console.error('Failed to load external header:', xhr.status);
					}
				}
			};
			xhr.send();
		}
	}
}

function addFAQ() {
	if (window.location.host.startsWith("aeroval-test.met.no")) {
		const url = 'https://docs.google.com/document/d/1B_YAE8bmmVyToAOSG6iJ0sXm3RSQl4antf85D7c0ZBM/pub';
		const menuListElement = document.querySelector('#navbarCollapse > ul')
		if (menuListElement) {
			var li = document.createElement("li");
			li.innerHTML = `
				<li class="nav-item">
					<a class="nav-link" href="${url}" title="FAQ"><i class="bi bi-question-circle-fill me-1"></i>FAQ</a>
				</li>`
			menuListElement.appendChild(li);
		}
	}
}